import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {computed} from "vue";
import {IconName, icons} from "./icons";
import FontAwesomeIcon from "./internal/FontAwesomeIcon.vue";

interface Props {
  name: IconName;
  monospace?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Icon',
  props: {
    name: {},
    monospace: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const fontAwesomeClasses = computed<string>((): string => icons[props.name]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FontAwesomeIcon, {
    class: _normalizeClass(fontAwesomeClasses.value),
    "fixed-width": props.monospace
  }, null, 8 /* PROPS */, ["class", "fixed-width"]))
}
}

})